<template>
  <div class="login-main" v-show="showLabel == 1">
    <div>
      <span class="title" style="font-size:30px">{{ $t('login.MS_ENERGY_Battery_Matrix') }}</span>
    </div>
    <el-input v-model="username" :placeholder="$t('login.Account')"
      style="font-size:18px;height:40px;margin-top:20px;"></el-input>
    <el-input :placeholder="$t('login.Password')" v-model="password" show-password
      style="margin-top:15px;font-size:18px;"></el-input>
    <div style="margin-top:15px;display:flex">
      <span class="forget-password"
        style="font-family: '楷体','楷体_GB2312';font-size:18px;color:#0049c8;margin-right:auto;margin-left:10px"
        @click="$emit('change', 2)">{{ $t('login.Forget_Password') }}</span>
      <span class="register"
        style="font-family: '楷体','楷体_GB2312';font-size:18px;color:#0049c8;margin-right:10px;margin-left:auto"
        @click="$emit('change', 3)">{{ $t('login.Register_for_free') }}</span>
    </div>
    <div>
      <div style="margin-top:30px;display:flex">
        <span class="u-checkbox tabfocus u-checkbox-select">
          <input id="un-login" type="checkbox" name="un-login" class="un-login" v-model="isAgree">
        </span>
        <span class="confirm"
          style="font-family: '楷体','楷体_GB2312';font-size:15px;margin-right: 5px;">{{ $t('login.Read_and_accept') }}</span>
        <span class="user-agreement"
          style="font-family: '楷体';font-size:15px;font-weight: bolder;text-decoration: underline;margin-right: 5px;">{{ $t('login.UserAgreement') }}</span>
        <span class="confirm" style="font-family: '楷体','楷体_GB2312';font-size:15px;margin-right: 5px;"> & </span>
        <span class="user-agreement"
          style="font-family: '楷体';font-size:15px;font-weight: bolder;text-decoration: underline;">{{ $t('login.PrivacyPolicy') }}</span>
      </div>
    </div>
    <el-button style="margin-top:30px;background:#0049c8;color:#ffffff;width:80%" @click="handleSubmit"
      @keyup.enter="keyDown(e)">{{ $t('login.log') }}</el-button>
  </div>
</template>

<script>
// import {load} from '@/api/api'
// import axios from 'axios';
import http from '@/utils/request';
export default {
  name: 'LoginVew',
  data() {
    return {
      username: '',
      password: '',
      isAgree: false,
      loginSuccess: false,
    }
  },
  props: {
    showLabel: {
      type: Number,
      required: true,
      default() {
        return 1
      }
    }
  },
  methods: {
    async keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode == 13) {
        this.handleSubmit(); // 定义的登录方法
      }
    },
    async handleSubmit() {
      var _this = this
      if (this.username == '' || this.password == '') {
        this.$message.error('账号密码不能为空');
        return;
      }
      if (!this.isAgree) {
        this.$message.error('请阅读并同意阅读用户协议和隐私政策');
        return;
      }
      try {
        await http.post('/proxy_url' + '/user/login', { 'account': this.username, 'pswd': this.password }).then(function (response) {
          if (response.data.code == 200) {
            var token = response.data.data['token']
            localStorage.setItem('token', token)
            _this.$router.push({
              path: '/diagnosis-management'
            })
          } else if (response.data.code == 1001) {
            _this.$message.error('用户不存在');
          }else if (response.data.code == 1002) {
            _this.$message.error('密码错误');
          }
          // console.log(response.data.code)
        })
        //   load({
        //     UserName: this.username,
        //     PassWord: this.password
        // })
        // .then(
        //   this.loginSuccess=true,
        //   // localStorage.setItem('token', token),
        //   this.$router.push({
        //         path: '/user-center'
        //     })
        //     )
      } catch (error) {
        console.log(error)
        // if(!this.loginSuccess){
        // this.$message.error('账号密码错误，请重新输入');
        // }
      }
      //   res => {
      //     console.log(res)
      //     // this.$alert('恭喜你登录成功了,但是我只写了这一个网页,要不你再登录一下?', '', {
      //     //     confirmButtonText: '确定'
      //     // });
      //     this.$message.success('登录成功');
      //     this.$router.push({
      //         name: '/home'
      //     })
      // }
    },
  },
  mounted() {
    // 绑定监听事件
    window.addEventListener("keydown", this.keyDown);
  },
  destroyed() {
    // 销毁事件
    window.removeEventListener("keydown", this.keyDown, false);
  }
}
</script>

<style>
.login-main {
  border-radius: 12px;
  margin-top: 150px;
  margin-right: 30px;
  padding: 30px;
  padding-top: 80px;
  background-color: #ffffff;
  /* border:1px solid #ccc; */
  width: 20%;
  display: inline block;
  height: 100%;
}

.title {
  padding: 100px 0 0;
  color: #141414;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
}</style>